import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/links";
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const anchor = document.getElementById("hero-cta");
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return <AnimatePresence data-id="element-34" data-mp="2ft3bmpvzfid7">
      {visible && <motion.div className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-navy-950/95 px-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 backdrop-blur" initial={{
      y: "100%"
    }} animate={{
      y: 0
    }} exit={{
      y: "100%"
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-35" data-mp="2avl3v2tpb96s">
          <a href={CHECKOUT_URL} className="mx-auto flex max-w-xl animate-shake items-center justify-center gap-2 rounded-2xl bg-gold px-4 py-4 font-display text-xl font-extrabold uppercase tracking-wide text-navy-950 shadow-cta focus-visible:outline focus-visible:outline-4 focus-visible:outline-offset-2 focus-visible:outline-brand motion-reduce:animate-none" data-id="element-36" data-mp="2z2hbegfajlx4">
            <span className="whitespace-nowrap" data-id="element-37" data-mp="2fcf2fy9f7fbw">Get instant access · $27</span>
            <ArrowRightIcon className="h-5 w-5 shrink-0" strokeWidth={3} aria-hidden="true" data-id="element-38" data-mp="2ke4cpbotjoyx" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}